// extracted by css-extract-rspack-plugin
export default {"Heading":"loading-card-module__Heading__kVKHP"};